var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4362 15.085L20.3762 19.095C20.5527 19.2858 20.648 19.5378 20.6419 19.7976C20.6358 20.0575 20.5288 20.3047 20.3435 20.487C20.1583 20.6693 19.9093 20.7722 19.6494 20.7741C19.3895 20.776 19.1391 20.6766 18.9512 20.497L15.0132 16.491C13.4938 17.6357 11.5961 18.1602 9.70452 17.9583C7.81291 17.7564 6.0687 16.8432 4.82506 15.4036C3.58142 13.9641 2.9313 12.1057 3.00633 10.2048C3.08136 8.30394 3.87593 6.5026 5.22916 5.16554C6.58238 3.82848 8.39314 3.05561 10.2948 3.00343C12.1964 2.95126 14.0468 3.62367 15.4714 4.88451C16.8959 6.14536 17.788 7.90042 17.9672 9.79432C18.1463 11.6882 17.5991 13.5794 16.4362 15.085ZM10.5002 16C11.9589 16 13.3579 15.4206 14.3893 14.3891C15.4208 13.3577 16.0002 11.9587 16.0002 10.5C16.0002 9.04134 15.4208 7.64239 14.3893 6.61094C13.3579 5.57949 11.9589 5.00003 10.5002 5.00003C9.04155 5.00003 7.64261 5.57949 6.61116 6.61094C5.57971 7.64239 5.00024 9.04134 5.00024 10.5C5.00024 11.9587 5.57971 13.3577 6.61116 14.3891C7.64261 15.4206 9.04155 16 10.5002 16Z",
    fill: "#656665"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a321f2825029b2dfec586882e8d19954.svg";
export { ForwardRef as ReactComponent };